/*
 * @Description: 视频中心界面
 * @Author: liuzhezhe
 * @Date: 2023-05-18 09:52:03
 * @LastEditors: 陈威达
 * @LastEditTime: 2024-10-29 12:18:10
 */
import React, { useState, useEffect, useRef } from 'react'
import styles from './index.scss'
import { Tabs, Pagination } from 'antd'
import axios from 'axios'
import { Link } from 'react-router-dom'
import videoImg from '../../common/images/video/video-img.png'
import { isMobileAgent } from '@/utils/utils'
import VideoSkeletons from './VideoSkeletons'
import VideoPcScreen from './VideoPcScreen'
import VideoList from './VideoPcScreen/VideoList'

const VideoCenter = (props) => {
  // https://api.bilibili.com/x/web-interface/wbi/view?aid=885145390
  const [headMeta, setMeta] = useState({})
  const [headList, setList] = useState([])
  const [tableData, setData] = useState([])
  const [tableList, setDataList] = useState([])
  const currentPageRef = useRef(1) // 目前的页数
  const season_id = useRef()
  const mate_season_id = useRef() // 获取头部视频显示的season_id
  // const [loadFlag, setLoadFlag] = useState(false)
  const nowData = useRef([]) // 需要把最新的noData值保存起来
  const total = useRef(0)
  const { TabPane } = Tabs
  // const mid = '100408831'
  const mid = '3493296187902689'
  const query = {
    mid,
    page_num: 1,
    page_size: 5
  }
  // 合集列表
  const getData = async(params) => {
    // axios({
    //   method: 'GET',
    //   url: 'x/web-interface/wbi/view?aid=885145390'
    // }).then(res => {
    //   console.log(res, 'res')
    // })
    axios({
      method: 'GET',
      // /x/polymer/web-space/seasons_series_list
      url: '/x/polymer/web-space/seasons_series_list',
      params
    }).then(res => {
      const data = res.data.data.items_lists.series_list
      const list = data.filter((item, index) => index > 0)
      list[2] = list.splice(3, 1, list[2])[0]
      const list_id = list[0].meta.series_id
      const data_id = data[0].meta.series_id
      setData(list.filter(item => item))
      season_id.current = list_id
      mate_season_id.current = data_id
      getParticularsList(list_id, false)
      getParticularsList(data_id, true)
    }).catch(err => {
      console.log(err, 'err')
    })
  }
  // let timer
  const getParticularsList = (key, partFlag = false) => {
    axios({
      method: 'GET',
      url: 'x/series/archives',
      params: {
        mid,
        series_id: key,
        only_normal: true,
        sort: 'desc',
        pn: currentPageRef.current,
        ps: 8
      }
    }).then(res => {
      const data = res.data.data.archives
      data.forEach(val => {
        const date = new Date(val.ctime * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        const Y = date.getFullYear() + '年'
        const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
        const D = date.getDate() + '日'
        val.ctime = Y + M + D
      })
      if (partFlag && !isMobileAgent()) {
        // 头部列表
        getHeadList(data)
      } else {
        // 【产品视讯】【产品功能】【会计学堂】【生态伙伴】列表
        total.current = res.data.data.page.total
        if (isMobileAgent()) {
          setMeta(data[0])
        }
        setDataList(data)
        nowData.current = data
        // setLoadFlag(false)
      }
    }).catch(err => {
      console.log(err, 'err')
      setMeta({})
      setDataList([])
      nowData.current = []
    })
  }
  const getHeadList = (data) => {
    setMeta(data[0])
    const list = data.filter((item, index) => index > 0 && index < 5)
    setList(list)
  }
  const getPage = (page) => {
    setDataList([])
    currentPageRef.current = page
    getParticularsList(season_id.current)
    window.scrollTo({
      top: 860
    })
  }
  // const handleScroll = (event) => {
  //   // 滚动的高度
  //   const scrollTop = event.srcElement ? event.srcElement.documentElement.scrollTop : 0
  //   // 可视区域的高度
  //   const clientHeight = event.srcElement ? event.srcElement.documentElement.clientHeight : 0
  //   // 滚动条内容的总高度
  //   const scrollHeight = event.srcElement ? event.srcElement.documentElement.scrollHeight - 1096 - 80 : 0
  //   if ((scrollTop + clientHeight >= scrollHeight) && nowData.current.length !== total.current) {
  //     if (!timer) {
  //       console.log('到底部了', timer, currentPageRef.current)
  //       setLoadFlag(true)
  //       timer = setTimeout(() => {
  //         timer = null
  //         currentPageRef.current++
  //         getParticularsList(season_id.current)
  //       }, 2000)
  //     }
  //   }
  // }
  useEffect(() => {
    currentPageRef.current = 1
    if (currentPageRef.current === 1) {
      getData(query)
    }
  }, [])
  const handleChangeKey = (key) => {
    console.log(key)
    currentPageRef.current = 1
    season_id.current = key
    getParticularsList(key, false)
  }
  const handleHeadMeta = (aid) => {
    const obj = tableList.find(val => val.aid === aid)
    const data = tableList.filter(val => val.aid !== aid)
    setList(data)
    if (obj) {
      setMeta(obj)
    }
    window.scrollTo({
      top: 0
    })
  }
  return (
    <div id='' className={`${styles['content']}`}>
      {/* PC端页面 */}
      <div className={styles['pc-content']}>
        <div className={styles['head-img']}>
          <img src={videoImg} alt='videoImg' />
        </div>
        <div className={styles['video']}>
          <h2>概而论视讯</h2>
          <div>
            {headMeta.aid && headMeta.bvid && headList && headList.length > 0 ? <div className={styles['video-herder']}>
              <div className={styles['video-left']}>
                {/* '//player.bilibili.com/player.html?aid=401211430&bvid=BV1Wo4y1F7fT&cid=1129119476&page=1" scrolling="no" border="0" frameBorder="no" framespacing="0"' */}
                <iframe className={styles['video-iframe']} title='bilibili' src={'//player.bilibili.com/player.html?aid=' + headMeta.aid + '&bvid=' + headMeta.bvid + '&page=1&danmaku=0'} autoPlay='0' danmaku='0' scrolling='no' border='0' frameBorder='0' framespacing='0' allowFullScreen={true} />
                <div className={styles['left-content']}>
                  <p className={styles['maxLine']}>{headMeta.title}</p>
                  <span className={styles['video-span']}>{headMeta.ctime}</span>
                </div>
              </div>
              <div className={styles['video-right']}>
                {
                  headList.map(item => {
                    return <Link to={{ pathname: `/video-detail/` + mate_season_id.current + '/' + item.aid }} className={styles['page-home-right']} target='_blank' key={item.aid}>
                      <div>
                        <img src={item.pic} alt={item.title} />
                      </div>
                      <p className={styles['maxLine']}>{item.title}</p>
                      <span className={styles['time']}>{item.ctime}</span>
                    </Link>
                  })
                }
              </div>
            </div> : <VideoPcScreen />}
          </div>
        </div>
        <div className={styles['tabs']}>
          {
            tableData && tableData.length > 0 && tableList && tableList.length > 0 ? <Tabs
              defaultActiveKey='video'
              type='card'
              onChange={handleChangeKey}
            >
              {tableData.map(item => {
                return <TabPane tab={item.meta.name} key={item.meta.series_id}>
                  <div className={styles['tabs-list']}>
                    {
                      tableList.map(val => {
                        return <Link to={{ pathname: `/video-detail/` + season_id.current + '/' + val.aid }} className={styles['page-home-right']} target='_blank' key={val.aid}>
                          <div className={styles['tabs-img']}><img src={val.pic} alt={val.pic} /></div>
                          <p className={styles['maxLine']}>{val.title}</p>
                          <span className={styles['time']}>{val.ctime}</span>
                        </Link>
                      })
                    }
                  </div>
                </TabPane>
              })}
            </Tabs> : <VideoList />}
          {/* {loadFlag && <div className={styles['load']}><Spin /></div>} */}
        </div>
      </div>
      {/* 移动端页面 */}
      {isMobileAgent() ? <div className={`${styles['yd-content']}`}>
        <div className={styles['yd-tabs']}>
          <Tabs
            defaultActiveKey='video'
            type='card'
            onChange={handleChangeKey}
            className={styles['yd_tabs']}
          >
            {
              tableData.map(item => {
                return <TabPane className={styles['tables']} tab={item.meta.name} key={item.meta.series_id}>
                </TabPane>
              })
            }
          </Tabs>
          <div className={styles['yd-video']}>
            <div className={styles['iframe-outer']}>
              <iframe title='bilibili' src={'//player.bilibili.com/player.html?aid=' + headMeta.aid + '&bvid=' + headMeta.bvid + '&page=1&danmaku=0'} autoPlay='0' danmaku='0' scrolling='no' border='0' frameBorder='0' framespacing='0' allowFullScreen={true} width='500' height='400' />
            </div>
            <p className={styles['maxLine']}>{headMeta.title}</p>
            <span className={styles['time']}>{headMeta.ctime}</span>
          </div>
          <ul className={styles['yd-tabs-list']}>
            {tableList && tableList.length > 0 ? tableList.map(val => {
              return (
                <li className={styles['list']} onClick={() => handleHeadMeta(val.aid)} key={val.aid}>
                  <div className={styles['tabs-img']}><img src={val.pic} alt={val.pic} /></div>
                  <p className={styles['maxLine']}>{val.title}</p>
                  <span className={styles['time']}>{val.ctime}</span>
                </li>
              )
            }) : <VideoSkeletons />}
          </ul>
          {/* {loadFlag && <div className={styles['load']}><Spin /></div>} */}
        </div>
      </div> : ''
      }
      <div className={styles['pagination']}>
        <Pagination showSizeChanger={false} pageSize={8} total={total.current} style={{ textAlign: 'center' }} current={currentPageRef.current} onChange={getPage} />
      </div>
    </div>
  )
}

export default VideoCenter
